import { trigger, style, transition, animate, keyframes } from '@angular/animations';

export const changeCountdown = trigger('changeCountdown', [
  transition('* => *', [
    animate(
      '600ms ease-out',
      keyframes([
        style({ transform: 'translateY(-50%) scale(1.1)', opacity: 0, offset: 0 }),
        style({ transform: 'translateY(0) scale(1)', opacity: 1, offset: 0.6 }),
        style({ transform: 'translateY(4px)', offset: 0.8 }),
        style({ transform: 'translateY(0)', offset: 0.9 }),
        style({ transform: 'scale(1.05)', offset: 0.95 }),
        style({ transform: 'scale(1)', offset: 1 }),
      ]),
    ),
  ]),
]);
